import { JSX } from 'react'

import { IconProps } from '../../icon'

const Informatica: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path d='M39.156 31.0675H11.3887V39.56H39.156V31.0675Z' fill='#D7D861' />
    <path
      d='M36.356 26.1222H10.8203C10.406 26.1222 10.0703 25.7865 10.0703 25.3722V23.047H37.106V25.3722C37.106 25.7865 36.7703 26.1222 36.356 26.1222Z'
      fill='#AAD3DC'
    />
    <path
      d='M12.9368 33.8137H11.829V32.706H12.9368V33.8137ZM12.9368 34.9215H11.829V36.0292H12.9368V34.9215ZM12.9368 37.1367H11.829V38.2445H12.9368V37.1367ZM15.1523 32.706H14.0445V33.8137H15.1523V32.706ZM15.1523 34.9215H14.0445V36.0292H15.1523V34.9215ZM15.1523 37.1367H14.0445V38.2445H15.1523V37.1367ZM17.3675 32.706H16.2598V33.8137H17.3675V32.706ZM17.3675 34.9215H16.2598V36.0292H17.3675V34.9215ZM23.9705 37.1367H16.2598V38.2445H23.9703V37.1367H23.9705ZM19.583 32.706H18.4753V33.8137H19.583V32.706ZM19.583 34.9215H18.4753V36.0292H19.583V34.9215ZM21.7985 32.706H20.6908V33.8137H21.7985V32.706ZM21.7985 34.9215H20.6908V36.0292H21.7985V34.9215ZM24.0138 32.706H22.906V33.8137H24.0138V32.706ZM24.0138 34.9215H22.906V36.0292H24.0138V34.9215ZM26.2292 32.706H25.1215V33.8137H26.2292V32.706ZM26.2292 34.9215H25.1215V36.0292H26.2292V34.9215ZM26.2292 37.1367H25.1215V38.2445H26.2292V37.1367ZM28.4447 32.706H27.337V33.8137H28.4447V32.706ZM28.4447 34.9215H27.337V36.0292H28.4447V34.9215ZM28.4447 37.1367H27.337V38.2445H28.4447V37.1367ZM32.8755 32.706H31.7677V33.8137H32.8755V32.706ZM32.8755 34.9215H31.7677V36.0292H32.8755V34.9215ZM32.8755 37.1367H31.7677V38.2445H32.8755V37.1367ZM35.091 32.706H33.9832V33.8137H35.091V32.706ZM35.091 34.9215H33.9832V36.0292H35.091V34.9215ZM35.091 37.1367H33.9832V38.2445H35.091V37.1367ZM37.3065 32.706H36.1987V33.8137H37.3065V32.706ZM37.3065 34.9215H36.1987V36.0292H37.3065V34.9215ZM37.3065 37.1367H36.1987V38.2445H37.3065V37.1367ZM39.5965 40H9.5V30.6275H39.5965V40ZM10.3805 39.1195H38.7162V31.5077H10.3805V39.1195ZM29.2898 29.8935H17.6298V29.013H19.6245V26.5625H11.391C10.42 26.5625 9.63025 25.7728 9.63025 24.8018V9.76075C9.63025 8.78975 10.42 8 11.391 8H35.7852C36.7563 8 37.546 8.78975 37.546 9.76075V24.8018C37.546 25.7728 36.7563 26.5625 35.7852 26.5625H26.655V29.0133H29.2898V29.8935ZM20.5048 29.0133H25.7745V26.5625H20.5048V29.0133ZM10.5108 23.4873V24.8018C10.5108 25.287 10.9057 25.6822 11.3912 25.6822H35.7855C36.2708 25.6822 36.666 25.2873 36.666 24.8018V23.4873H10.5108ZM10.5108 22.6067H36.6658V9.76075C36.6658 9.2755 36.2708 8.88025 35.7852 8.88025H11.391C10.9058 8.88025 10.5105 9.27525 10.5105 9.76075V22.6067H10.5108Z'
      fill='black'
    />
  </svg>
)

export default Informatica
